@if (dashboardInfoDto$ | async; as dashboardInfoDto) {
    <div class="content" data-qa="dashboard">
        @if (shouldDisplayTodoListHeadline(dashboardInfoDto)) {
            <h2>Ihre Aufgaben</h2>
        }
        <div fxLayout="column" class="todo-list">
            @if (shouldDisplayDatenabfrageATSTask(dashboardInfoDto)) {
                <mat-card
                    data-qa="hinweis-datenabfrage">
                    <tnb-notify-datenabfrage
                        [aktiveDatenAbfrage]="dashboardInfoDto.aktiveDatenAbfrage"></tnb-notify-datenabfrage>
                </mat-card>
            }
            @if (dashboardInfoDto.numberOfDeleteNetzzuordnung > 0 && dashboardInfoDto.isErzeugungsAnlagenPflegeAktiv) {
                <mat-card
                    data-qa="hinweis-netzzuordnungen">
                    <tnb-dashboard-netzzuordnungen
                        [invalidNetzzuordnungen]="dashboardInfoDto.numberOfDeleteNetzzuordnung"
                    ></tnb-dashboard-netzzuordnungen>
                </mat-card>
            }
            @if (dashboardInfoDto.numberOfUncofirmedNetzzuordnungUUIDs > 0) {
                <mat-card
                    data-qa="hinweis-uuid-confirmation"
                    fxFlex>
                    <tnb-dashboard-uuid-change-confirmation
                        [lastConfirmedUuidDate]="dashboardInfoDto.lastConfirmedUuidDate"
                        [numberOfUnconfirmedNetzzuordnungen]="dashboardInfoDto.numberOfUncofirmedNetzzuordnungUUIDs"
                    ></tnb-dashboard-uuid-change-confirmation>
                </mat-card>
            }
            @if (dashboardInfoDto.isErzeugungsanlageLastChangedAndNetzbeteiberLastUpdateToOld && dashboardInfoDto.isErzeugungsAnlagenPflegeAktiv) {
                <mat-card
                    data-qa="hinweis-datenaktualisierung"
                    fxFlex>
                    <tnb-uptodate-confirmation
                    ></tnb-uptodate-confirmation>
                </mat-card>
            }
        </div>
        <div class="row-wrap">
            <div fxLayout="column">
                <h2>Ihre Übersicht</h2>
                <tnb-dashboard-info-box [dashboardInfoDTO]="dashboardInfoDto"
                                        [isCurrentUserWestnetzUser]="authService.isWestnetzUserOrWestnetzAdmin(tnbUser)"
                                        fxLayout="column"></tnb-dashboard-info-box>
            </div>
            @if (netzbetreiberService.shouldDisplayErzeugerDetails(dashboardInfoDto)) {
                <div class="power-unit-view-container"
                     fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="1rem">
                    <h2>Split nach Energieart</h2>
                    <mat-button-toggle-group [(ngModel)]="leistungseinheitViewMode"
                                             (change)="toggleViewMode($event)"
                                             appearance="standard"
                                             class="power-unit-view-selector">
                        <mat-button-toggle data-qa="kw-view" value="{{Leistungseinheit.KW}}">
                            kW
                        </mat-button-toggle>
                        <mat-button-toggle data-qa="mw-view" value="{{Leistungseinheit.MW}}">
                            MW
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                    <tnb-aggregated-installierte-leistung-by-energieart
                        [aggregations]="installierteLeistungByEnergieart$ | async"
                        [leistungseinheit]="leistungseinheitViewMode">
                    </tnb-aggregated-installierte-leistung-by-energieart>
                </div>
            }
        </div>
        @if (netzbetreiberService.shouldDisplayErzeugerDetails(dashboardInfoDto)) {
            <h2>Split nach Anlagentypen</h2>
        }
        @if (netzbetreiberService.shouldDisplayErzeugerDetails(dashboardInfoDto)) {
            <tnb-aggregated-installierte-leistung-by-anlagentyp
                [aggregations]="installierteLeistungByAnlagentyp$ | async"
                [leistungseinheit]="leistungseinheitViewMode">
            </tnb-aggregated-installierte-leistung-by-anlagentyp>
        }

        <div fxLayout="row" fxLayoutAlign="space-around stretch" fxLayoutGap="1rem">
            <div fxFlex fxLayout="column">
                @if (dashboardInfoDto.netzzuordnungImport) {
                    <h2>Netzzuordnungsimport</h2>
                    <tnb-netzzuordnung-import-report [netzzuordungImport]="dashboardInfoDto.netzzuordnungImport">
                    </tnb-netzzuordnung-import-report>
                }
                @if (dashboardInfoDto.netzzuordnungImport === null) {
                    <h2>Netzzuordnungsimport</h2>
                    <mat-card class="netzzuordnungs-import-card">
                        <p>es liegt kein Netzzuordnungsimport über die v5 Schnittstelle vor</p>
                    </mat-card>
                }
            </div>
        </div>
    </div>
}
